import moment from 'moment'

function date(value, format) {
  if (value) {
    return moment(String(value)).format(format || 'MM/DD/YYYY')
  }
}

function capitalize(value) {
  if (!value) return ''
  return value.toLowerCase().split(' ').map(val => val.charAt(0).toUpperCase() + val.slice(1)).join(' ')
}

function unsnake(str) {
  return str.split('_').join(' ')
}

function number(value, extionsion) {
  if (!value) return 'None'

  return Number.parseFloat(value).toFixed(extionsion || 2)
}

function currency(num, currencyLabel) {
  let currencyMapper = {
    'USD': {symbol: '$'},
    'ILS': {symbol: '₪'},
  };

  return num ? num + currencyMapper[currencyLabel].symbol : '-'
}

function fullname(fullname) {
  let fullNameSplit = fullname.split(/\s+/)

  return (fullNameSplit.length > 1 && fullname.length > 18) ? `${fullNameSplit[0][0]}. ${fullNameSplit.slice(1).join(' ')}` : fullname
}

export {date, capitalize, unsnake, number, currency, fullname}
